const COMPANY_UNUSUAL_COLOR = "#FA8072";
const SUCCESS_COLOR = "#B4D3B2";

import moment from "moment";
import momentTz from "moment-timezone";
import { stageIdBySlug } from "@/objects/stageLoader";

export default {
  key: "application",
  serviceKey: "hrdc",
  name: {
    singular: "Application",
    plural: "Applications",
  },
  parents: [
    //
  ],
  add: {
    name: "Add Application",
  },
  view: {
    name: "View Application",
  },
  edit: {
    name: "Edit Application",
  },
  browse: {
    table: {
      headers: [
        {
          formatter: "rowSelection",
          titleFormatter: "rowSelection",
          titleFormatterParams: {
            rowRange: "active", //only toggle the values of the active filtered rows
          },
          hozAlign: "left",
          headerSort: false,
          filterable: false,
          searchable: false,
          headerFilter: false,
          selectableColumn: false,
          visible: false,
        },
        {
          title: "#",
          filterable: false,
          searchable: false,
          headerFilter: false,
          headerSort: false,
          selectableColumn: false,
          visible: true,
          width: 80,
          formatter: (cell) => {
            const rowData = cell.getData();
            const num = rowData.rownum;
            let badges = '';

            if (rowData.isApplicationDuplicate) {
              badges += `<span class="tbl-idx-badge tbl-idx-badge--dup" title="Application Duplicate"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" width="11" height="11"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" /></svg></span>`;
            }

            if (rowData.isFlag) {
              badges += `<span class="tbl-idx-badge tbl-idx-badge--flag normal-flag"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="11" height="11"><path fill-rule="evenodd" d="M3 2.25a.75.75 0 0 1 .75.75v.54l1.838-.46a9.75 9.75 0 0 1 6.725.738l.108.054a8.25 8.25 0 0 0 5.58.652l.96-.24a.75.75 0 0 1 .921.727v8.769a.75.75 0 0 1-.53.719l-.96.24a9.75 9.75 0 0 1-6.59-.77l-.108-.053a8.25 8.25 0 0 0-5.69-.625l-1.454.364V21a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75Z" clip-rule="evenodd" /></svg></span>`;
            }

            return `<span class="tbl-idx">${num}</span>${badges}`;
          },
        },
        {
          title: "Company",
          field: "company",
          dataType: "onlyLikeEqualNotEqual",
          filterable: true,
          searchable: true,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "left",
          headerWordWrap: true,
          // width: 300,
          formatter: (cell) => {
            const data = cell.getData();
            const companyName = data.oriCompanyName;

            // Set color danger if refund type is 70/30
            if (data.refundType == 2) {
              cell.getElement().classList.add("tbl-cell--warning");
            }

            return `<span class="tbl-company-link">${companyName.toUpperCase()}</span>`;
          },
        },
        {
          title: "Client",
          field: "picName",
          dataType: "onlyLikeEqualNotEqual",
          filterable: true,
          searchable: true,
          sortable: false,
          // Not sortable: picName is not a column of the browse query — the API
          // stitches it in from a separate CompanyPicDetail aggregation after
          // the fact, so it is absent from the sort whitelist and an
          // ORDER BY on it produces invalid SQL.
          headerSort: false,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "left",
          headerWordWrap: true,
          showByDefault: false,
        },
        {
          title: "Client Contact No.",
          field: "clientPicContactNo",
          dataType: "onlyLikeEqualNotEqual",
          filterable: false,
          searchable: true,
          headerSort: false,
          sortable: false,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "left",
          headerWordWrap: true,
          showByDefault: false,
        },
        {
          title: "Customer Service",
          field: "csName",
          dataType: "onlyLikeEqualNotEqual",
          headerSort: false,
          filterable: false,
          searchable: true,
          sortable: false,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "left",
          headerWordWrap: true,
          visible: true,
          showByDefault: false,
          formatter(cell) {
            let cs = cell.getValue();
            if (cs == "nul") {
              return "-";
            }
            return cs;
          },
        },
        {
          title: "Responder",
          field: "responderName",
          dataType: "onlyLikeEqualNotEqual",
          filterable: true,
          searchable: true,
          sortable: false,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "left",
          headerWordWrap: true,
        },
        {
          title: "taxPOD Type",
          field: "taxpodType",
          dataType: "onlyLikeEqualNotEqual",
          filterable: true,
          searchable: true,
          sortable: false,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "center",
          headerWordWrap: true,
          widthGrow: 0.8,
          formatter(cell) {
            let taxpodType = cell.getValue();
            if (taxpodType == 1) {
              return `<span class="tbl-pill tbl-pill--blue">New Sale</span>`;
            }
            if (taxpodType == 2) {
              return `<span class="tbl-pill tbl-pill--amber">Renewal</span>`;
            }

            return taxpodType;
          },
        },
        {
          title: "Payment Channel",
          field: "isPaymentMade",
          dataType: "onlyLikeEqualNotEqual",
          filterable: true,
          searchable: true,
          sortable: false,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "center",
          headerWordWrap: true,
          widthGrow: 0.9,
          formatter(cell) {
            let isPaymentMade = cell.getValue();
            if (isPaymentMade == true) {
              return `<span class="tbl-pill tbl-pill--purple">Pay & Refund</span>`;
            }
            if (isPaymentMade == false) {
              return `<span class="tbl-pill tbl-pill--slate">Claim Basis</span>`;
            }

            return isPaymentMade;
          },
        },
        {
          title: "Price (RM)",
          field: "price",
          dataType: "onlyLikeEqualNotEqual",
          filterable: true,
          searchable: true,
          sortable: false,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "center",
          headerWordWrap: true,
          width: 130,
          formatter(cell) {
            const raw = parseInt(cell.getValue());
            const val = raw.toLocaleString();
            // Color based on base pricing: 2888, 2388, 1998, 1798, 1498
            const base = raw % 2888 === 0 ? 2888
              : raw % 2388 === 0 ? 2388
              : raw % 1998 === 0 ? 1998
              : raw % 1798 === 0 ? 1798
              : raw % 1498 === 0 ? 1498
              : 0;
            const colorMap = {
              2888: 'tbl-price--red',
              2388: 'tbl-price--blue',
              1998: 'tbl-price--purple',
              1798: 'tbl-price--amber',
              1498: 'tbl-price--green',
            };
            const colorClass = colorMap[base] || 'tbl-price--blue';
            return `<span class="tbl-price-badge ${colorClass}"><span class="tbl-price-badge__currency">RM</span>${val}</span>`;
          },
        },
        {
          title: "Claim ID",
          field: "claimId",
          dataType: "onlyLikeEqualNotEqual",
          filterable: true,
          searchable: true,
          sortable: false,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "center",
          headerWordWrap: true,
          showByDefault: false,
          formatter(cell) {
            const claimId = cell.getValue();
            if (claimId) {
              return claimId;
            }
            return "-";
          },
        },
        {
          title: "Grant Approval No.",
          field: "grantApprovalNo",
          dataType: "onlyLikeEqualNotEqual",
          filterable: false,
          searchable: true,
          sortable: false,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "center",
          headerWordWrap: true,
          showByDefault: false,
          formatter(cell) {
            const grantApprovalNo = cell.getValue();
            if (grantApprovalNo) {
              return grantApprovalNo;
            }
            return "-";
          },
        },
        {
          title: "Credit Note No.",
          field: "creditNoteNo",
          dataType: "onlyLikeEqualNotEqual",
          filterable: false,
          searchable: true,
          sortable: false,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "center",
          headerWordWrap: true,
          showByDefault: false,
          formatter(cell) {
            const creditNoteNo = cell.getValue();
            if (creditNoteNo) {
              return creditNoteNo;
            }
            return "-";
          },
        },
        {
          title: "taxPOD Invoice No.",
          field: "autoGeneratedTaxpodInvoiceNo",
          dataType: "onlyLikeEqualNotEqual",
          filterable: false,
          searchable: true,
          sortable: false,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "center",
          headerWordWrap: true,
          showByDefault: false,
          formatter(cell) {
            const autoGeneratedTaxpodInvoiceNo = cell.getValue();
            if (autoGeneratedTaxpodInvoiceNo) {
              return autoGeneratedTaxpodInvoiceNo;
            }
            return "-";
          },
        },
        {
          title: "HRDC Invoice",
          field: "manualInvoiceToHrdc",
          dataType: "onlyLikeEqualNotEqual",
          filterable: false,
          searchable: true,
          sortable: false,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "center",
          headerWordWrap: true,
          showByDefault: false,
          formatter(cell) {
            const manualInvoiceToHrdc = cell.getValue();
            if (manualInvoiceToHrdc) {
              return manualInvoiceToHrdc;
            }
            return "-";
          },
        },
        {
          title: "Training Start Date",
          field: "trainingStartDate",
          dataType: "date",
          filterable: false,
          searchable: true,
          sortable: false,
          headerFilter: false,
          headerSort: false,
          selectableColumn: true,
          hozAlign: "center",
          headerWordWrap: true,
          showByDefault: false,
          formatter(cell) {
            const trainingStartDate = cell.getValue();
            if (trainingStartDate) {
              return momentTz(trainingStartDate).format("YYYY-MM-DD");
            }
            return "-";
          },
        },
        {
          title: "Stages",
          field: "stages",
          dataType: "onlyLikeEqualNotEqual",
          filterable: true,
          searchable: true,
          sortable: false,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "left",
          // width: 250,
          headerWordWrap: true,
          formatter(cell) {
            let stageName = cell.getValue();
            const cellData = cell.getData();
            const today = moment().startOf("day");
            let trainingEndDate = null;
            let grantApplyDate = null;
            const SENT_CONFIRMATION_EMAIL_TO_CLIENT = stageIdBySlug(
              "hrdc",
              "editApplication"
            );
            const MANUAL_INVOICE_TO_HRDC = stageIdBySlug(
              "hrdc",
              "manualInvoiceToHrdc"
            );

            switch (cellData.stageNameSlug) {
              case "clientRevertT3Form":
                stageName = generateStageName(cellData, "clientRevertT3Form");
                break;
              case "manualInvoiceToHrdc":
                if (cellData.stageId == MANUAL_INVOICE_TO_HRDC) {
                  trainingEndDate = moment(
                    cellData.trainingEndDate,
                    "YYYY-MM-DD HH:mm:ssZ"
                  );
                  // If subscription date (26-29), can only submit claim on 30th (SOP to avoid HRDC query).
                  if (
                    trainingEndDate.isAfter(today) ||
                    trainingEndDate.isSame(today)
                  ) {
                    cell.getElement().classList.add("tbl-cell--warning");
                  } else {
                    cell.getElement().classList.add("tbl-cell--success");
                  }
                }

                break;

              case "sentConfirmationEmailToClient":
                if (cellData.stageId == SENT_CONFIRMATION_EMAIL_TO_CLIENT) {
                  let cellColor = SUCCESS_COLOR;
                  if (cellData.grantApplyDate) {
                    grantApplyDate = moment(
                      cellData.grantApplyDate,
                      "YYYY-MM-DD HH:mm:ssZ"
                    );

                    if (today.isAfter(grantApplyDate)) {
                      cellColor = COMPANY_UNUSUAL_COLOR;
                    }
                  }
                  if (cellColor === COMPANY_UNUSUAL_COLOR) {
                    cell.getElement().classList.add("tbl-cell--warning");
                  }
                }

                stageName = generateStageName(
                  cellData,
                  "clientRevertFormIncomplete"
                );
                break;

              case "grantApproved":
                stageName = generateStageName(cellData, "grantApproved");
                break;

              case "formsCompleted":
                stageName = generateStageName(cellData, "formsCompleted");
                break;

              case "clientRevertFormIncomplete":
                stageName = generateStageName(
                  cellData,
                  "clientRevertFormIncomplete"
                );
                break;

              case "claimApprovedFromHrdc":
                if (cellData.isPaymentReceivedPassGracePeriod == true) {
                  stageName += `
                    <i title="Late than 7 days received payment" aria-hidden="true" class="v-icon notranslate mdi mdi-information-slab-circle-outline theme--light" style="cursor: pointer; color: #ef4444; font-size: 14px;"></i>
                  `;

                  cell.getElement().classList.add("tbl-cell--warning");
                }
                break;

              case "submittedClaimToHrdc":
                if (cellData.isHrdcClaimApprovalPassGracePeriod == true) {
                  stageName += `
                    <i title="Late than 4 days claim approval from HRDC" aria-hidden="true" class="v-icon notranslate mdi mdi-information-slab-circle-outline theme--light" style="cursor: pointer; color: #ef4444; font-size: 14px;"></i>
                  `;

                  cell.getElement().classList.add("tbl-cell--warning");
                }

                break;

              case "refundEmailApToCimbRejected":
                cell.getElement().classList.add("tbl-cell--warning");
                break;
            }
            return `<span class="tbl-stage">${stageName}</span>`;
          },
        },
        {
          title: "Revert Form Status",
          field: "revertFormStatus",
          dataType: "onlyLikeEqualNotEqual",
          filterable: true,
          searchable: false,
          sortable: false,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "left",
          headerWordWrap: true,
          visible: false,
          formatter(cell) {
            let cellStatus = cell.getValue();
            let revertStatus = null;
            if (cellStatus) {
              revertStatus = "Completed";
            } else {
              revertStatus = "Incompleted";
            }

            return revertStatus;
          },
        },
        {
          title: "Order By Refund Email Submission Date",
          field: "REFUND_EMAIL_SUBMISSION",
          dataType: "boolean",
          filterable: true,
          searchable: false,
          sortable: false,
          headerFilter: false,
          selectableColumn: false,
          hozAlign: "left",
          headerWordWrap: false,
          showByDefault: false,
        },
        {
          title: "Order By Refund Email Approval 1 Date",
          field: "REFUND_EMAIL_APPROVAL_1",
          dataType: "boolean",
          filterable: true,
          searchable: false,
          sortable: false,
          headerFilter: false,
          selectableColumn: false,
          hozAlign: "left",
          headerWordWrap: false,
          showByDefault: false,
        },
        {
          title: "Order By Refund Email Approval 2 Date",
          field: "REFUND_EMAIL_APPROVAL_2",
          dataType: "boolean",
          filterable: true,
          searchable: false,
          sortable: false,
          headerFilter: false,
          selectableColumn: false,
          hozAlign: "left",
          headerWordWrap: false,
          showByDefault: false,
        },
        {
          title: "Manual Invoice Ready",
          field: "manualInvoiceReady",
          dataType: "onlyLikeEqualNotEqual",
          filterable: true,
          searchable: false,
          sortable: false,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "left",
          headerWordWrap: true,
          visible: false,
        },
        {
          title: "Submission Date",
          field: "timestampCreated",
          dataType: "onlyLikeEqualNotEqual",
          filterable: false,
          searchable: false,
          sortable: false,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "left",
          headerWordWrap: true,
          showByDefault: false,
          formatter: (cell) => {
            const value = cell.getValue();
            let createdDate = moment(value).format("YYYY-MM-DD HH:mm");
            return createdDate;
          },
        },
        {
          title: "Payment Received Expired",
          field: "paymentReceivedExpired",
          dataType: "onlyLikeEqualNotEqual",
          filterable: true,
          searchable: false,
          sortable: false,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "center",
          headerWordWrap: true,
          showByDefault: false,
        },
        {
          title: "Finance AP Sent Date",
          field: "orderByRefundEmailFinanceAp",
          dataType: "onlyLikeEqualNotEqual",
          filterable: true,
          searchable: false,
          sortable: false,
          headerFilter: false,
          selectableColumn: true,
          hozAlign: "center",
          headerWordWrap: true,
          showByDefault: false,
          formatter: (cell) => {
            const value = cell.getValue();

            if (value) {
              let date = moment(value).format("YYYY-MM-DD HH:mm");
              return date;
            }

            return "-";
          },
        },
        {
          title: "Completed Date",
          field: "completedTime",
          dataType: "onlyLikeEqualNotEqual",
          filterable: false,
          searchable: false,
          sortable: false,
          headerFilter: false,
          headerSort: false,
          selectableColumn: true,
          hozAlign: "left",
          headerWordWrap: true,
          showByDefault: false,
          formatter: (cell) => {
            const value = cell.getValue();
            if (value) {
              let createdDate = moment(value).format("YYYY-MM-DD HH:mm");
              return createdDate;
            }

            return "-";
          },
        },
        {
          title: "Claim Submit Date",
          field: "claimSubmitDate",
          dataType: "onlyLikeEqualNotEqual",
          filterable: false,
          searchable: false,
          sortable: false,
          headerFilter: false,
          headerSort: false,
          selectableColumn: true,
          hozAlign: "center",
          headerWordWrap: true,
          showByDefault: false,
          formatter: (cell) => {
            return formatClaimSubmitDate(cell.getValue());
          },
        },
        {
          title: "Training Date",
          field: "trainingDate",
          dataType: "onlyLikeEqualNotEqual",
          filterable: false,
          searchable: false,
          sortable: false,
          headerFilter: false,
          headerSort: true,
          selectableColumn: true,
          hozAlign: "center",
          headerWordWrap: true,
          showByDefault: false,
          formatter: (cell) => {
            const data = cell.getData();
            const trainingStartDate = moment(data.trainingStartDate).format(
              "YYYY-MM-DD"
            );
            const trainingEndDate = moment(data.trainingEndDate).format(
              "YYYY-MM-DD"
            );
            return `${trainingStartDate} - ${trainingEndDate}`;
          },
        },
        {
          title: "taxPOD Subscription Date",
          field: "subscriptionStartDate",
          dataType: "onlyLikeEqualNotEqual",
          filterable: false,
          searchable: false,
          sortable: false,
          headerFilter: false,
          headerSort: true,
          selectableColumn: true,
          hozAlign: "center",
          headerWordWrap: true,
          showByDefault: false,
          formatter: (cell) => {
            const data = cell.getData();

            const startMoment = moment(data.subscriptionStartDate);
            const endMoment = moment(data.subscriptionEndDate);

            // Some legacy rows persist the literal string "Invalid date" (or
            // null) in these VarChar columns, so guard on real date validity
            // rather than truthiness — otherwise moment() just re-emits
            // "Invalid date". Invalid/missing values fall through to "-".
            if (
              data.subscriptionStartDate &&
              data.subscriptionEndDate &&
              startMoment.isValid() &&
              endMoment.isValid()
            ) {
              const subscriptionStartDate = startMoment.format("YYYY-MM-DD");
              const subscriptionEndDate = endMoment.format("YYYY-MM-DD");

              if (data.taxpodType == 2) {
                const endDate = new Date(data.subscriptionEndDate);
                const today = new Date();

                endDate.setHours(0, 0, 0, 0);
                today.setHours(0, 0, 0, 0);

                const msInADay = 1000 * 60 * 60 * 24;
                const diffInMs = today - endDate;
                const diffInDays = diffInMs / msInADay;

                if (diffInDays > 14) {
                  cell.getElement().classList.add("tbl-cell--info");
                }
              }

              return `${subscriptionStartDate} - ${subscriptionEndDate}`;
            }

            return "-";
          },
        },
        {
          title: "Claim Approved Date",
          field: "claimApprovedDate",
          dataType: "onlyLikeEqualNotEqual",
          filterable: false,
          searchable: false,
          sortable: false,
          headerFilter: false,
          headerSort: false,
          selectableColumn: true,
          hozAlign: "center",
          headerWordWrap: true,
          showByDefault: false,
          formatter: (cell) => {
            const value = cell.getValue();
            if (value) {
              return moment(value).format("YYYY-MM-DD");
            }

            return "-";
          },
        },
      ],
    },
  },
};

/**
 * The API sends "Claim Submit Date" pre-rendered as one sentence:
 * "2026-05-22" when on time, "2026-05-22 (Late <b><u>52</u></b> days)" when the
 * claim missed its grace date. That buries the only actionable part — how late
 * it is — inside body copy. This splits the string back into its two facts and
 * renders the date as data with the delay as a severity badge beneath it.
 *
 * Anything that stops matching falls through to the original string, so a
 * change to the API's wording degrades to today's rendering rather than a
 * blank cell.
 */
function formatClaimSubmitDate(value) {
  if (!value) return "-";

  const raw = String(value);
  const dateMatch = raw.match(/\d{4}-\d{2}-\d{2}/);
  if (!dateMatch) return raw;

  // \D+ spans the "<b><u>" the API wraps the number in.
  const lateMatch = raw.match(/Late\D+(\d+)\D+days/i);
  const date = `<span class="tbl-claimdate__date">${dateMatch[0]}</span>`;

  if (!lateMatch) {
    return `<span class="tbl-claimdate tbl-claimdate--ontime">${date}</span>`;
  }

  const days = Number(lateMatch[1]);
  // The count is in working days past the grace date, so any value is already a
  // breach; the tiers separate a slip from a backlog from an escalation.
  const level = days <= 3 ? "warn" : days <= 10 ? "high" : "crit";
  const clockIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="11" height="11"><path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75V6Z" clip-rule="evenodd" /></svg>`;

  return `
    <span class="tbl-claimdate">
      ${date}
      <span class="tbl-claimdate__late tbl-claimdate__late--${level}" title="Submitted ${days} working day${
    days === 1 ? "" : "s"
  } after the expected claim date">
        ${clockIcon}
        <span>${days} day${days === 1 ? "" : "s"} late</span>
      </span>
    </span>
  `;
}

function generateAlert(type, title, content) {
  const icons = {
    success: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clip-rule="evenodd" /></svg>`,
    error: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clip-rule="evenodd" /></svg>`,
    warning: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="14" height="14"><path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" clip-rule="evenodd" /></svg>`,
  };

  return `
    <span class="tbl-stage-alert tbl-stage-alert--${type}" title="${title}">
      ${icons[type]}
      <span class="tbl-stage-alert__text">${content}</span>
    </span>
  `;
}

function generateStageName(cellData, caseType) {
  let stageName = `<span style="display: inline-flex; flex-direction: column; align-items: flex-start; gap: 4px;">`;

  switch (caseType) {
    case "grantApproved":
      if (cellData.isJd14FormSubmitted || cellData.isT3FormSubmitted) {
        stageName += generateAlert(
          "warning",
          "JD14 & T3 Form is submitted but got issue",
          "JD14 & T3 Form"
        );
      } else {
        stageName += generateAlert(
          "error",
          "JD14 & T3 Form is not submit",
          "JD14 & T3 Form"
        );
      }

      stageName += generateAlert(
        "success",
        "Grant No. is completed",
        "Grant No."
      );
      break;

    case "formsCompleted":
      stageName += generateAlert(
        "success",
        "JD14 & T3 Form is completed",
        "JD14 & T3 Form"
      );

      if (cellData.grantApprovalNo) {
        stageName += generateAlert(
          "warning",
          "Grant No. is submitted but got issue",
          "Grant No."
        );
      } else {
        stageName += generateAlert(
          "error",
          "Grant No.is submitted but got issue ",
          "Grant No."
        );
      }
      break;

    case "clientRevertFormIncomplete":
      if (cellData.isJd14FormSubmitted || cellData.isT3FormSubmitted) {
        stageName += generateAlert(
          "warning",
          "JD14 & T3 Form is submitted but got issue",
          "JD14 & T3 Form"
        );
      } else {
        stageName += generateAlert(
          "error",
          "JD14 & T3 Form is not submit",
          "JD14 & T3 Form"
        );
      }

      if (cellData.grantApprovalNo) {
        stageName += generateAlert(
          "warning",
          "Grant No. is submitted but got issue",
          "Grant No."
        );
      } else {
        stageName += generateAlert(
          "error",
          "Grant No. is not submit",
          "Grant No."
        );
      }
      break;

    case "clientRevertT3Form":
      stageName += generateAlert(
        "success",
        "JD14 & T3 Form is completed",
        "JD14 & T3 Form"
      );

      stageName += generateAlert(
        "success",
        "Grant No. is completed",
        "Grant No."
      );
      break;
  }

  stageName += `</span>`;
  return stageName;
}
